export default __webpack_public_path__ + "static/media/jeff_jpg.9f421f60.jpg";